import { useEffect } from 'react';

import { useRouter } from 'next/router';

import type { NextPage } from 'next';

//talkに統合されたのでリダイレクト処理のみ(amplifyのインフラの方でもリダイレクトを設定する)
const Contact: NextPage = () => {
  const router = useRouter();

  useEffect(() => {
    //戻る無限ループになるのでreplace
    router.replace('/chat/talk?redirect=contact');
  }, []);

  return <></>;
};

export default Contact;
